webpackJsonp([10],{

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListWrapper_vue__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d377728_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListWrapper_vue__ = __webpack_require__(754);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d377728"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d377728_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(737);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("cfeff512", content, true);

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".dashboard[data-v-3d377728]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.buttonRow[data-v-3d377728]{margin-top:1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", "", {"version":3,"sources":["/app/src/components/Dashboard/ListWrapper.vue"],"names":[],"mappings":"AACA,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAgB,CACrB,AACD,4BACE,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC","file":"ListWrapper.vue","sourcesContent":["\n.dashboard[data-v-3d377728] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.buttonRow[data-v-3d377728] {\n  margin-top: 1em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_notify_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_eventBus__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListRow__ = __webpack_require__(739);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: {
    DashboardRow: __WEBPACK_IMPORTED_MODULE_4__ListRow__["a" /* default */]
  },
  computed: {
    videos: function videos() {
      return this.$store.getters['submission/list'];
    },
    needInfoVideos: function needInfoVideos() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.moreinfo] || []));
    },
    pendingVideos: function pendingVideos() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.incomplete] || []));
    },
    activeVideos: function activeVideos() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.fasttrack] || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.pending] || []));
    },
    inactiveVideos: function inactiveVideos() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.approved] || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.videos[__WEBPACK_IMPORTED_MODULE_2__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.rejected] || []));
    }
  },
  methods: {
    scrollToGroup: function scrollToGroup(index) {
      var group = this.$refs['dashboardGroup' + index];
      if (group) {
        group.$el.scrollIntoView();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('submission/list').catch(function (error) {
      _this.$notify.error({
        title: error.message,
        message: 'There is an error listing your submissions. Please contact us if the problem persist',
        duration: __WEBPACK_IMPORTED_MODULE_1__config_notify_constants__["a" /* default */].DURATION.FOREVER
      });
      throw error;
    });
    __WEBPACK_IMPORTED_MODULE_3__libs_eventBus__["a" /* default */].$on('dashboard/scrollToGroup', this.scrollToGroup);
  }
});

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRow_vue__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef581122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRow_vue__ = __webpack_require__(753);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef581122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("5d16f50a", content, true);

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".dashboard__row{border-bottom:1px solid rgba(0,0,0,.1);padding-bottom:3em;margin-bottom:3em}.dashboard__row:last-of-type{border-bottom:none;padding-top:0;margin-top:0}", "", {"version":3,"sources":["/app/src/components/Dashboard/ListRow.vue"],"names":[],"mappings":"AAoHA,gBACE,uCAA4C,AAC5C,mBAAoB,AACpB,iBAAmB,CACpB,AACD,6BACE,mBAAoB,AACpB,cAAe,AACf,YAAc,CACf","file":"ListRow.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.dashboard__row {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding-bottom: 3em;\n  margin-bottom: 3em;\n}\n.dashboard__row:last-of-type {\n  border-bottom: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_CardCol__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItemAddButton__ = __webpack_require__(748);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardAddButton: __WEBPACK_IMPORTED_MODULE_2__ListItemAddButton__["a" /* default */],
    DashboardItem: __WEBPACK_IMPORTED_MODULE_1__ListItem__["a" /* default */],
    CardCol: __WEBPACK_IMPORTED_MODULE_0__components_Shared_CardCol__["a" /* default */]
  },
  props: {
    videos: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    hasAddButton: {
      type: Boolean,
      default: false
    },
    hasPendingWarning: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItem_vue__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f413864_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItem_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f413864_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(745);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("1ed6df80", content, true);

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".item{-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;height:auto;height:300px;background-color:#fbfbfb;color:#000}.item,.item .el-card__body{display:-webkit-box;display:-ms-flexbox;display:flex}.item .el-card__body{width:100%;height:100%;padding:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item .item__body{margin-bottom:auto;padding:40px 20px;height:218px;overflow:hidden}.item .item__footer{-webkit-box-shadow:0 1px 1px 0 rgba(0,0,0,.1);box-shadow:0 1px 1px 0 rgba(0,0,0,.1);margin-top:auto;padding:1px 10px;padding-top:2px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:rgba(0,0,0,.02)}.item .item__footer .el-button{margin:0;border:none;background-color:transparent}.item__title{margin-top:0;-webkit-line-clamp:2;margin-bottom:0}.item__description,.item__title{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.item__description{font-size:.8em;line-height:1.5em;opacity:.8;-webkit-line-clamp:5}.item__year{font-size:.6em;opacity:.5}.item__delete{padding-left:2px;padding-right:2px}", "", {"version":3,"sources":["/app/src/components/Dashboard/ListItem.vue"],"names":[],"mappings":"AAoHA,MAIE,yBAA0B,AACtB,sBAAuB,AACnB,wBAAyB,AACjC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,YAAgB,AAChB,aAAc,AACd,yBAA0B,AAC1B,UAAa,CACd,AACD,2BAfE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAwBf,AAXD,qBACI,WAAY,AACZ,YAAa,AACb,UAAW,AACX,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAIlC,AACD,kBACI,mBAAoB,AACpB,kBAAmB,AACnB,aAAc,AACd,eAAiB,CACpB,AACD,oBACI,8CAAmD,AAC3C,sCAA2C,AACnD,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,wBAAyB,AACjC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAsC,CACzC,AACD,+BACM,SAAU,AACV,YAAa,AACb,4BAA8B,CACnC,AACD,aACE,aAAc,AAEd,qBAAsB,AAGtB,eAAiB,CAClB,AACD,gCANE,oBAAqB,AAErB,4BAA6B,AAC7B,eAAiB,CAWlB,AARD,mBACE,eAAiB,AACjB,kBAAmB,AACnB,WAAa,AAEb,oBAAsB,CAGvB,AACD,YACE,eAAiB,AACjB,UAAa,CACd,AACD,cACE,iBAAkB,AAClB,iBAAmB,CACpB","file":"ListItem.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: stretch;\n      -ms-flex-pack: stretch;\n          justify-content: stretch;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  height: initial;\n  height: 300px;\n  background-color: #fbfbfb;\n  color: black;\n}\n.item .el-card__body {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.item .item__body {\n    margin-bottom: auto;\n    padding: 40px 20px;\n    height: 218px;\n    overflow: hidden;\n}\n.item .item__footer {\n    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n    margin-top: auto;\n    padding: 1px 10px;\n    padding-top: 2px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: stretch;\n        -ms-flex-pack: stretch;\n            justify-content: stretch;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    background-color: rgba(0, 0, 0, 0.02);\n}\n.item .item__footer .el-button {\n      margin: 0;\n      border: none;\n      background-color: transparent;\n}\n.item__title {\n  margin-top: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n.item__description {\n  font-size: 0.8em;\n  line-height: 1.5em;\n  opacity: 0.8;\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.item__year {\n  font-size: 0.6em;\n  opacity: 0.5;\n}\n.item__delete {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_data_viddsee_submissionStatus__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    video: {}
  },
  computed: {
    statusInfo: function statusInfo() {
      return __WEBPACK_IMPORTED_MODULE_0__assets_data_viddsee_submissionStatus__["a" /* default */].getInfo(this.video.status);
    }
  },
  methods: {
    openSubmission: function openSubmission() {
      this.$router.push('submission/' + this.video.id);
    },
    triggerDelete: function triggerDelete() {
      var _this = this;

      this.$confirm('Are you sure you want to delete "<strong>' + this.video.title + '</strong>"?', 'Warning', {
        dangerouslyUseHTMLString: true, // `video.title` is expected to be sanitized
        confirmButtonText: 'Delete submission',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        return _this.deleteSubmission();
      });
    },
    deleteSubmission: function deleteSubmission() {
      var _this2 = this;

      return this.$store.dispatch('submission/remove', this.video).then(function () {
        _this2.$message({
          type: 'success',
          message: 'Delete completed'
        });
      }).catch(function (error) {
        _this2.$message({
          type: 'error',
          message: 'Unable to delete submission. (' + error + ')'
        });
        throw error;
      });
    }
  }
});

/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"item item-status",class:_vm.video.status},[_c('el-row',{staticClass:"item__footer"},[_c('el-col',{staticStyle:{"flex-shrink":"2"}},[_c('el-tag',{style:({
          background: 'none',
              border: 'none',
               color: _vm.statusInfo.color,
        })},[_vm._v(_vm._s(_vm.statusInfo.label))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"right"}},[_c('div',{staticClass:"item__buttons"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.openSubmission}},[_vm._v("\n          "+_vm._s(_vm.statusInfo.editable ? 'Edit' : 'View')+"\n        ")]),_vm._v(" "),(_vm.statusInfo.deletable)?_c('el-button',{staticClass:"item__delete",attrs:{"size":"small","icon":"el-icon-delete"},on:{"click":_vm.triggerDelete}}):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"item__body"},[_c('h2',{staticClass:"item__title"},[_vm._v("\n      "+_vm._s(_vm.video.title || 'Untitled')+"\n      "),_c('small',{staticClass:"item__year"},[_vm._v("\n        "+_vm._s(_vm.video.year || '')+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"item__description"},[_vm._v("\n      "+_vm._s(_vm.video.description_long || '')+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItemAddButton_vue__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4e9a896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItemAddButton_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItemAddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4e9a896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItemAddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("cd498cec", content, true);

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".item--empty{position:absolute;border:none}", "", {"version":3,"sources":["/app/src/components/Dashboard/ListItemAddButton.vue"],"names":[],"mappings":"AAoHA,aACE,kBAAmB,AACnB,WAAa,CACd","file":"ListItemAddButton.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.item--empty {\n  position: absolute;\n  border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"item"},[_c('el-button',{staticClass:"item--empty",on:{"click":function($event){_vm.$router.push("submission")}}},[_c('i',{staticClass:"el-icon-plus",staticStyle:{"font-size":"3em"}}),_vm._v(" "),_c('p',[_vm._v("Add a new film")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videos.length > 0 || _vm.hasAddButton)?_c('div',{staticClass:"dashboard__row"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasPendingWarning)?_c('h4',[_vm._v("Our review period requires a minimum of 2 weeks.")]):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_vm._l((_vm.videos),function(video){return _c('CardCol',{key:video.id},[_c('DashboardItem',{attrs:{"video":video}})],1)}),_vm._v(" "),(_vm.hasAddButton)?_c('CardCol',[_c('DashboardAddButton')],1):_vm._e()],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"buttonRow"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.$router.push("submission")}}},[_vm._v("\n        Add a new film\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.$router.push("series-license")}}},[_vm._v("\n        Add a new series\n      ")])],1),_vm._v(" "),_c('DashboardRow',{ref:"dashboardGroup0",attrs:{"videos":_vm.needInfoVideos,"title":"Need more info"}}),_vm._v(" "),_c('DashboardRow',{ref:"dashboardGroup1",attrs:{"videos":_vm.pendingVideos,"title":"Incomplete","hasAddButton":true}}),_vm._v(" "),_c('DashboardRow',{ref:"dashboardGroup3",attrs:{"videos":_vm.activeVideos,"title":"Under Review","hasPendingWarning":true}}),_vm._v(" "),_c('DashboardRow',{ref:"dashboardGroup4",attrs:{"videos":_vm.inactiveVideos,"title":"Reviewed"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/10.dfe5837302c8561fec59.js